<template lang="pug">
  .height-100
    transition(name="fade")
      editar-administrador-funciones(
        :cargo="cargo"
        v-if="mostrarModalEditar",
        @close="closeModalEditar",
        @closeRefresh="closeModalEditar(true)"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionEliminar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionEliminar = false"
        @do="validarEliminar"
        ref="confirmarEliminar"
      )
        span(slot="title") ¿Desea eliminar el cargo {{ solicitudSeleccionada.cargo }}?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Eliminando...
          template(v-else)
            | Eliminar
        div.info-validar-eliminar(slot="information")
          template(v-if="empleadosValidados.length > 0")
            span No se puede eliminar el cargo ya que tiene empleados asociados:
            ul
              li(v-for="(o, index) in empleadosValidados" :key="index")
                span {{ o.nombre }}


    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .title
          span Administrador de funciones
        .filtros-container
          .control.flex-1.title-singular
            p Cargo
            .input-container
              input.input(
                type="text",
                v-model="cargo"
                :disabled="isLoading"
                @click="mostrarBusquedaCargo = true"
              )
              span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaCargo = true")
                i.fa.fa-search
              .erase-data(@click="cargo = ''; fetch()")
                .icon
                  .fa.fa-times
            transition(name="fade-quick")
              .pop-over(
                  v-if="mostrarBusquedaCargo"
                )
                lookup-cargo(
                  @selected="seleccionarCargo"
                  @close="mostrarBusquedaCargo = false"
                )
          .text-right.acciones
            button.button.is-small.margin-right-5.is-primary(@click="openModalEditar('')")
              span.icon.is-small
                i.fa.fa-plus
              span Nuevo
            button.button.is-small(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh
              span Refrescar

        .body
          .information
            transition-group.contenedor-data(
              v-infinite-scroll="fetchByScroll"
              infinite-scroll-disabled="disabledScrollExecute"
              infinite-scroll-distance="2"
              name="fade-smooth-two"
              tag="div"
            )
              table.table.is-striped.is-bordered(
                v-if="lista.length !== 0"
                key="table-lista"
              )
                thead

                  th Cargo
                  th
                tbody(
                  name="table-row"
                  is="transition-group"
                )
                  tr.row-table(
                    v-for="(o, index) in lista"
                    :key="index"
                    @dblclick="openModalEditar(o.cargo)"

                  )
                    td
                      span {{ o.cargo }}
                    td.text-center
                      .td-wrapper
                        .contenedor-acciones
                          template(v-if="o.pathPdf")
                            template(v-if="o.pathPdf.startsWith('http')")
                              a.button.is-small(:href="o.pathPdf", target="_blank")
                                span.icon.is-small
                                  i.fa.fa-paperclip.is-small
                                span Ver adjunto
                            template(v-else)
                              button.button.is-small(type="button", @click="verAdjuntoLegacy(o.pathPdf)")
                                span.icon.is-small
                                  i.fa.fa-paperclip.is-small
                                span Ver adjunto
                          button.button.is-small.mt-10(@click="openModalEditar(o.cargo)")
                            span.icon.is-small
                              i.fa.fa-pencil-square-o
                            span Editar
                          button.button.is-small.is-danger(@click="confirmarEliminar(o)")
                            span.icon.is-small
                              i.fa.fa-times
                            span Eliminar
          .is-loading(v-if="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
          .message.is-warning(v-if="lista.length === 0 && !isLoading")
            .message-body
              span.has-text-bold No hay registros
</template>

<script>
import ComponentAdministradorFuncionesEditar from '../components/Component_Administrador_Funciones_Editar'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import ComponentLookupCargo       from './Component_Lookup_Cargo';

import { apiGet, notify, apiDelete } from '../util/general'
import { scrollTo } from '../util/scroll'
export default {
  name: 'administrador-funciones',
  data () {
    return {
      lista              : [],
      isLoading          : false,
      mostrarModalEditar : false,
      cargo     : null,
      isScroll               : false,
      disabledScrollExecute : true,
      skip                   : 0,
      noMore                 : false,
      solicitudSeleccionada  : null,
      mostrarConfirmacionEliminar : false,
      empleadosValidados: [],
      isSending: false,
      mostrarBusquedaCargo: false
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  components: {
    'editar-administrador-funciones': ComponentAdministradorFuncionesEditar,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent,
    'lookup-cargo':ComponentLookupCargo
  },
  mounted () {
    this.fetch()
  },
  methods: {
    seleccionarCargo (o) {
      var vm = this
      vm.cargo = o.cargo
      vm.fetch()
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      vm.disabledScrollExecute = true
      vm.noMore = false
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      var obj = {
        skip: vm.skip,
        cargo: vm.cargo
      }
      apiGet(vm, '/funciones_pdf/obtener', obj, function (data) {
        data.lista.forEach(function (o) {
          // o.fecha = moment(o.fecha).format('DD/MM/YYYY HH:mm:ss')
          vm.lista.push(o)
        })
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    verAdjuntoLegacy (pathPdf) {
      let url = process.env.API_ROUTE + '/funciones_pdf/mostrarPath?ruta=' + pathPdf
      window.open(url, '_blank')
    },
    openModalEditar (cargo) {
      var vm = this
      if (cargo) vm.cargo = cargo
      vm.mostrarModalEditar = true
    },
    closeModalEditar (refresh) {
      var vm = this
      vm.mostrarModalEditar = false
      vm.cargo = null
      if (refresh) vm.fetch()
    },
    confirmarEliminar (o) {
      this.empleadosValidados = []
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionEliminar = true
      let contenedor = document.getElementsByClassName('contenedor')[0];
      if (window.getComputedStyle(contenedor).overflow !== 'auto') {
        this.$nextTick(() => {
          scrollTo({
            vm:this,
            ref:this.$refs.confirmarEliminar.$el,
            mobile: 0,
            desktop: -400,
            hasOverlay: false
          });
        })
      }
    },
    eliminar () {
      var vm = this
      var obj = {
        cargo: vm.solicitudSeleccionada.cargo
      }
      apiDelete(vm, '/funciones_pdf', obj, function (data) {
        vm.mostrarConfirmacionEliminar = false
        notify(vm, 'success', 'Éxito', data.message)
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    validarEliminar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        cargo: vm.solicitudSeleccionada.cargo
      }
      apiDelete(vm, '/funciones_pdf/validarEliminar', obj, function (data) {
        if (data.lista.length > 0) {
          vm.empleadosValidados = data.lista
          vm.isSending = false
        } else {
          vm.eliminar()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  .acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px
  .input-container
    display flex
    align-items center
    .input
      flex 1
      width 100px
    .erase-data
      cursor pointer
      margin-left 5px
  .info-validar-eliminar
    max-height: 200px;
    overflow-y: scroll;
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px
  .title-singular
    text-align left
    font-weight bold
    user-select: none
    width: 400px
  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    display: flex
    justify-content: center;
    align-items: flex-end;
    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%

        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde

  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px

  .modal-sidebar-desktop-open
    width: calc(100% - 180px);

  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width: 620px)
    .filtros-container
      flex-direction: column
      .control
        padding-bottom 10px

  @media (max-width 500px)
    .title-singular
      width: 300px
  @media (max-width 450px)
    .table
      font-size 12px
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column
        .contenedor-acciones
          flex-direction: column
          .button
            margin-bottom 5px
            &:last-child
              margin-bottom 0px
  @media (max-width 400px)
   .title-singular
    width: 279px


</style>




// WEBPACK FOOTER //
// Component_Administrador_Funciones.vue?75decef0